import CssBaseline from '@mui/material/CssBaseline';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { ReactNode } from 'react';
import { ArSmartflowTheme } from './ar-smartflow-theme';

export default function ArSmartflowThemeProvider({
    children,
}: {
    children: ReactNode;
}) {
    return (
        <ThemeProvider theme={ArSmartflowTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}
